import { flattenProgramTree, programPath } from "../program-tree/program-tree";

import type { ProgramNode, ProgramTree } from "../program-tree/program-tree";

export interface MoveDestination {
  node: ProgramNode;
  depth: number;
  /** The titles of the programs above it, from the top down. */
  path: string;
  /** The Communication is in it now. */
  current: boolean;
  /** It cannot be picked, because the Communication is in it now or the caller cannot edit it. */
  disabled: boolean;
}

/** The titles of the program and each program above it, from the top down. */
export const pathText = (tree: ProgramTree, id: string): string =>
  programPath(tree, id)
    .map(({ title }) => title)
    .join(" › ");

const hasEditable = (node: ProgramNode): boolean =>
  node.editable || node.children.some(hasEditable);

/**
 * The programs and folders that a Communication can move to, in the order the switcher shows them.
 * Without a query, each one the caller can edit is there, with the ones above it to show where it
 * is. With a query, only the ones the caller can edit whose title has the query are there.
 */
export const moveDestinations = (
  tree: ProgramTree,
  currentId: string,
  query: string,
): MoveDestination[] => {
  const q = query.trim().toLowerCase();
  return flattenProgramTree(tree)
    .filter(({ node }) =>
      q ? node.editable && node.title.toLowerCase().includes(q) : hasEditable(node),
    )
    .map(({ node, depth }) => ({
      node,
      depth,
      path: node.parent_id ? pathText(tree, node.parent_id) : "",
      current: node.id === currentId,
      disabled: node.id === currentId || !node.editable,
    }));
};
